import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import decode from "jwt-decode";
import Storage from "../../utils/storage";
import PropTypes from "prop-types";
import jwt_decode from "jwt-decode";
import { clearStorage } from "../../utils/Api/api";
const PrivateRoute = ({
  component: Component,
  currentUser,
  // eslint-disable-next-line no-unused-vars
  isAuthenticated,
  ...rest
}) => {
  const initialstate = {
    user: null,
  };

  if (Storage.get("user-access-token")) {
    const keep = Storage.get("keep");
    const jwt_Token_decoded = jwt_decode(Storage.get("user-access-token"));
    const jwt_Refresh_Token_decoded = jwt_decode(
      Storage.get("user-access-refresh-token")
    );

    if (
      jwt_Token_decoded.exp * 1000 < Date.now() &&
      (keep === "false" || keep === false)
    ) {
      clearStorage();
    } else {
      initialstate.user = jwt_Token_decoded;
    }

    if (
      jwt_Refresh_Token_decoded.exp * 1000 < Date.now() &&
      (keep === "true" || keep === true)
    ) {
      clearStorage();
      return <Redirect to="/login" />;
    }
  }

  let userInstorage =
    Storage.get("user-access-token") &&
    decode(Storage.get("user-access-token"));
  if (!currentUser && !userInstorage) {
    return <Redirect to="/login" />;
  }

  return <Route {...rest} component={Component} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  currentUser: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isAuthenticated: PropTypes.bool,
  logOutUser: PropTypes.any,
  refreshUserToken: PropTypes.func,
};

PrivateRoute.defaultProps = {
  component: null,
};

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(PrivateRoute);


